import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { LoadingScreenService } from '../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../global.service';

@Component({
  selector: 'app-pop-iptv-create',
  templateUrl: './pop-iptv-create.component.html',
  styleUrls: ['./pop-iptv-create.component.sass']
})
export class PopIptvCreateComponent implements OnInit {
public channels: number;
  public allChannels;

  constructor(private global: GlobalService, private router: Router, public dialog: MatDialog, public matDialogRef: MatDialogRef<PopIptvCreateComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private route: ActivatedRoute, private loadingScreenService: LoadingScreenService) {
    if (data.channels != null) {
      this.channels = data.channels;
    }
  }
  ngOnInit() {
   
  }

  continue() {
    this.matDialogRef.close('accept');
  }
  public close(msg) {
    this.matDialogRef.close('cancel');
  }
}
